<script>
    //@ts-nocheck
    import {
        BackDrop,
        Modal,
        CheckBox,
        Button,
        Form,
        TailSpinner,
        Alert,
    } from '$lib/components/UI'
    import AlertValidacion from './AlertValidacion.svelte'
    import DatosProveedor from '$lib/components/forms/DatosProveedor.svelte'
    import { onMount } from 'svelte'
    import { createEventDispatcher } from 'svelte'
    import InformacionImpositiva from '$lib/components/forms/InformacionImpositiva.svelte'
    import Terminos from './Terminos.svelte'
    import DocumentationSelector from './DocumentationSelector.svelte'
    import AcreditacionCuenta from '$lib/components/forms/AcreditacionCuenta.svelte'
    import Track from '$lib/components/UI/Track.svelte'
    export let show = false
    export let configStep = true
    export let renderSections = []
    export let restricted = false
    export let inputs = []
    export let fetching = false
    export let review = false
    export let comment = ''

    const dispatch = createEventDispatcher()
    let options = {
        dp: {
            label: 'Información de contacto',
            value: false,
            component: DatosProveedor,
        },
        ii: {
            label: 'Información Impositiva',
            value: false,
            component: InformacionImpositiva,
        },
        // lp:  { label: 'Información Laboral y previsional', value: false, component: InformacionLaboral },
        ac: {
            label: 'Información de Bancaria',
            value: false,
            component: AcreditacionCuenta,
        },
        doc: {
            label: 'Documentación',
            value: false,
            component: DocumentationSelector,
        },
    }

    let current = 0
    let terminos = false
    export let providerData = {}
    // providerData = {}
    let data = structuredClone(providerData)
    // console.log({providerData})
    // let data = Object.entries(providerData).filter(([k]) => k !== 'personal_lp').reduce((acc, [k, v]) => ({...acc, [k]: v}), {});
    let valid
    let diffData
    let dataToFetch = {}
    let docValidations = {}
    let incorrectFields = {}
    let allRequired = false
    $: providerSiniestros = providerData.tipo_proveedor_ii === '4'
    function resetData() {
        data = structuredClone(providerData)
        // docData = {};
        console.log('Reset data!')
    }
    $: steps = Object.entries(options)
        .filter(([_, o]) => o.value)
        .map(([k, { label, component }]) => ({ k, label, component }))
        .concat([
            { label: 'Términos y condiciones', component: Terminos, k: 'tc' },
        ])

    $: if (providerData || data) {
        let a = Object.entries(structuredClone(data)).reduce(
            (acc, [k, v]) => ({ ...acc, [k]: JSON.stringify(v) }),
            {}
        )
        let b = Object.entries(structuredClone(providerData)).reduce(
            (acc, [k, v]) => ({ ...acc, [k]: JSON.stringify(v) }),
            {}
        )
        let ks = Object.keys(a).filter((k) => k in b)
        diffData = ks
            .filter((k) => a[k] !== b[k] && !/observacion.+/.test(k))
            .map((k) => [k, a[k], b[k]])
        // console.log({diffData});
    }
    $: currentSf = steps[current]?.k || 'st'
    $: detectChanges = ['st', 'tc', 'doc', 'lp'].includes(currentSf)
        ? true
        : diffData.filter(([k]) => k.substr(-2) == currentSf).length > 0
    let formData = {}
    let docData = {}
    $: dataToFetch = diffData
        .map(([k]) => [k, data[k]])
        .concat(Object.entries(docData))
        .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {})
    $: docValidation =
        currentSf == 'doc'
            ? Object.values(docValidations).every((x) => x) &&
              Object.keys(docData).length > 0
            : true
    $: if (!configStep) {
        resetData()
    }
    $: if (review === true) {
        renderSections = ['dp', 'ii', 'ac'] //'lp'
    }

    $: console.log({ docValidations, data })
    onMount((_) => {
        resetData()
        options = Object.entries(options)
            .map(([k, v]) => [k, { ...v, value: renderSections?.includes(k) }])
            .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {})
        if (renderSections instanceof Array && renderSections.length > 0) {
            configStep = false
        }
    })
    $: console.log({ review })
</script>

<BackDrop visible={show} style="position:fixed">
    <Modal
        let:scrollControl
        title="Solicitud de modificación"
        subtitle={configStep
            ? 'Seleccione al menos una opción'
            : 'A continuación siga los pasos'}
        style="width: 66%; min-width: 500px; height: auto; max-height: 85%"
        scrolleable
        on:close={(_) => (show = false)}
        on:clickout={(_) => (show = false)}
    >
        <span class="content">
            <!-- STEP 1 -->
            {#if configStep}
                {#each Object.entries(options) as [k, { label }]}
                    <CheckBox
                        bind:value={options[k].value}
                        disabled={k === 'doc' &&
                            !Object.values(options)
                                .map(({ value }) => value)
                                .some((x) => x)}
                        label={`Quiero modificar mi ${label}`}
                    />
                {/each}
            {:else}
                <!-- STEP 2 -->
                <Track bind:current breakPoints={steps} />
                {#if comment && currentSf !== 'tc'}
                    <Alert style="margin: 5px 0" type="warning"
                        >{@html comment}</Alert
                    >
                {/if}
                <Form
                    bind:valid
                    bind:raw={formData}
                    bind:incorrectFields
                    bind:allRequired
                >
                    {#if !['tc', 'doc', 'st'].includes(currentSf)}
                        <svelte:component
                            this={steps[current]?.component}
                            bind:data
                            showDoc={false}
                            dynamic={false}
                            {providerSiniestros}
                            {inputs}
                            {restricted}
                        />
                        <br />
                        {#key incorrectFields || allRequired}
                            <AlertValidacion {incorrectFields} />
                        {/key}
                    {:else if currentSf === 'doc'}
                        <DocumentationSelector
                            bind:validations={docValidations}
                            conditions={data}
                            bind:data={docData}
                        />
                    {:else}
                        <svelte:component
                            this={steps[current]?.component}
                            bind:fetching
                            bind:value={terminos}
                        />
                    {/if}
                    {#if fetching}
                        <Alert type="info"
                            >Por favor no cierre la pestaña hasta que la
                            operación sea completada.</Alert
                        >
                    {/if}
                </Form>
            {/if}
        </span>
        <svelte:fragment slot="buttonSet">
            <!-- <p>{JSON.stringify({valid, docValidation, currentSf, detectChanges})}</p> -->
            {#if !configStep && (renderSections.length === 0 || current !== 0)}
                <Button
                    label="Atras"
                    disabled={fetching}
                    type="other"
                    on:click={(_) => {
                        if (current == 0) {
                            configStep = true
                        } else {
                            current -= 1
                        }
                    }}
                />
            {/if}
            <Button
                disabled={!(configStep
                    ? steps.length - 1 > 0
                    : valid &&
                      (detectChanges || review) &&
                      allRequired &&
                      (currentSf == 'tc' ? terminos : true) &&
                      !fetching &&
                      docValidation)}
                on:click={() => {
                    if (configStep) {
                        configStep = false
                    } else {
                        if (currentSf !== 'tc') {
                            current += 1
                        } else {
                            fetching = true
                            dispatch('success', { data: dataToFetch })
                        }
                    }
                    scrollControl.scrollTop = 0
                }}
                label={current === steps.length - 1
                    ? configStep
                        ? 'Continuar'
                        : 'Enviar'
                    : 'Continuar'}
            >
                {#if fetching}
                    <TailSpinner size={25} />
                {/if}
            </Button>
        </svelte:fragment>
    </Modal>
</BackDrop>

<style>
    .content {
        /* background: rgba(0, 0, 0, 0.05); */
        position: relative;
        display: flex;
        width: 100%;
        flex-direction: column;
    }
</style>
